export const TOOLTIPS_CONTENT = {
  imagePlayer: 'Загрузите изображение птички. Автоматически обрежется в круг с помощью интуитивного редактора и конвертируется в WebP для лучшей производительности. Рекомендуется квадратное изображение',
  urlButton: 'Текст, который будет отображаться при проигрыше. Рекомендуется до 10 символов',
  textTitle: 'Текст заголовка игры. Рекомендуется до 15 символов',
  customMusic: 'Формат MP3 или WAV. Размер до 5мб. Будет играть на фоне во время игры',
  testGame: 'Демо режим. Игра будет работать в тестовом режиме',
  createGame: 'После нажатия игра начнет создавать и вы получите ссылку на готовую игру',
};

export const REQUIRED_FIELDS = {
  imagePlayer: true,
  urlButton: false,
  textTitle: false,
  customMusicFile: false,
};
